"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllFeatureToggleNames = exports.getFullFeatureToggleObject = void 0;
var getFullFeatureToggleObject = function (value) {
    var result = {
        accessories: value,
        bypassCaching: value,
        bypassFinanceDriverLead: value,
        bypassVppCategoryMapping: value,
        convertDecimalTaxRateToPercentInMV: value,
        coreIsMaster: value,
        createDealFinishMyDeal: value,
        creditApp: value,
        creditAppRedirectToSDP: value,
        creditOverwriteBlock: value,
        counterOfferNavToAccept: value,
        customerCardSV: value,
        dashPaymentOnlyMenuSelections: value,
        dashUseIncentivesActivity: value,
        dashUseMenuActivity: value,
        dashUseTradeActivity: value,
        dealerManualSend: value,
        dealServiceGatewayCalls: value,
        displayMyTermsOnSDP: value,
        docUploadFsDealRefId: value,
        docUploadValidation: value,
        enableABPencilStateMV: value,
        enableAccelerateBranding: value,
        enableAcceleronPaymentFailureHandling: value,
        enableActivEngageCoBrowse: value,
        enableAdobe_perpetual: value,
        enableAfterMarketWarrantyCreditData: value,
        enableAio: value,
        enableAioCreateDealReadFromV3: value,
        enableAioDocUploadEvent: value,
        enableAioV2: value,
        enableAioV2Dxg: value,
        enableAioV2Publish: value,
        enableAioV2S3: value,
        enableAioV2Save: value,
        enableAioWriteV4: value,
        enableAmdV4DxgFields: value,
        enableAnalyticsLogging: value,
        enableAnalyticsRelayRetry: value,
        enableAppliedLenderInfo: value,
        enableApsApiForTestDealers: value,
        enableAudioEye: value,
        enableAuryc: value,
        enableBuyRateForCreditDecision: value,
        enableCAOChat: value,
        enableCashIncentives: value,
        enableChangeVehicle: value,
        enableCoBuyer: value,
        enableCommonOrgIdForPendo: value,
        enableConditionalSpecials: value,
        enableConsumerFacingDecisionsDDP: value,
        enableConsumerInsightsLambdaV2: value,
        enableCreditAppDealXgInit: value,
        enableCreditAppInfoRecord: value,
        enableCreditAppOccupationField: value,
        enableCreditAppRedesign: value,
        enableCreditBureauAndDecisionPBCs: value,
        enableCreditBureauAndDecisionPBCRouteOne: value,
        enableCreditDecisionDetails: value,
        enableCustomerCardNotifications: value,
        enableDCaccessories: value,
        enableDealerComments: value,
        enableDealLifeCycle: value,
        enableDealLookup: value,
        enableDealMessageHistory: value,
        enableDigitalDealJacket: value,
        enableNotifyFromDxg: value,
        enableOptionalPbcUi: value,
        enableSellAnyVehicleSV: value,
        enableVppExistsCheck: value,
        enabledEditZipOnDealSummary: value,
        enableDeskingActivity: value,
        enableDIO: value,
        enableDocUpload: value,
        enableDocUploadAutomation: value,
        enableDocUploadRoles: value,
        enabledPersistentSend: value,
        enableDpm: value,
        enableDrProfile: value,
        enabledSkipTradeLanding: value,
        enabledTradeInOnPayment: value,
        enableDxgGlobalParticipantsDedupe: value,
        enableEmailRedesign: value,
        enableEnhancedPushToDmsPlusMV: value,
        enableFIETokenAuthorization: value,
        enableFniFailFeatureToggle: value,
        enableFniFailure: value,
        enableGhostVinDealer: value,
        enableGoogleTagManager: value,
        enableHelpContacts: value,
        enableHideRouteOneCreditBureau: value,
        enableHighestMarkUpDecision: value,
        enableHowItWorks: value,
        enableIcoAmsiTradeOnSDP: value,
        enableIcoTradeInOnSP: value,
        enableInterstateAccessories: value,
        enableInterstateBridgeBar: value,
        enableInterstateContinueInDeskingAndSendToCustomer: value,
        enableInterstateDealLifeCycle: value,
        enableInterstateDealProgress: value,
        enableInterstateDealSummary: value,
        enableInterstateDealType: value,
        enableInterstateGrid: value,
        enableInterstateHeader: value,
        enableInterstateIncentivesSection: value,
        enableInterstateOfferComments: value,
        enableInterstateOfferHistory: value,
        enableInterstateTradeSection: value,
        enableInterstateUi: value,
        enableInterstateVehicleProtection: value,
        enableItemizedIncentivesSDP: value,
        enableItemizedIncentivesVDP: value,
        enableLambdaAcceptOffer: value,
        enableLambdaGetOffer: value,
        enableLambdaGetTerms: value,
        enableLambdaSubmitOffer: value,
        enableLambdaUpdateOffer: value,
        enableLatestDealNotifications: value,
        enableLeadFormOnDealStarter: value,
        enableLeadFormOnSDPExit: value,
        enableLeaseDealSummaryNewLabels: value,
        enableLegacyIncentivesFromActivity: value,
        enableLenderLogos: value,
        enableLoggingDecisionPayload: value,
        enableMenuOnCash: value,
        enableMenuSelectionsRevertLogic: value,
        enableMobileModal: value,
        enableMobileSubHeader: value,
        enableMUITestDriveWithRedesign: value,
        enableMVFeesCrud: value,
        enableNavActivityStatus: value,
        enableNavigateToInitDeepLinkRoute: value,
        enableNewAccelerateLogo: value,
        enableNewAddTaxesAndFeesBtnOnSP: value,
        enableNewKBBAndATCMobileHeader: value,
        enableNewPaymentWorkFlowChange: value,
        enableNewrelicTest: value,
        enableNextStepsModalOnVDP: value,
        enableOptimizelyDealStarter: value,
        enableOptimizelyShopperPlatform: value,
        enableP202Redesign: value,
        enablePaymentBuildingCards: value,
        enablePaymentFallbackMessageFromNdsOrAtcWallet: value,
        enablePendoInMV: value,
        enablePlanSelectionForVPP: value,
        enablePmtboxReskin: value,
        enablePostOfferMessaging: value,
        enablePreferredPaymentApiSelection: value,
        enablePriceAdvisorCTA: value,
        enablePriceBreakdown: value,
        enablePushToR1: value,
        enablePushToDarwin: value,
        enableQuestionsCaching: value,
        enableRedesignedHeader: value,
        enableReservationLambdaShopperNotification: value,
        enableReservationStartOnLeadForm: value,
        enableRTS: value,
        enableSDPTradeInLeadCopyTest: value,
        enableSellAnyVehicle: value,
        enableShareDeal: value,
        enableShareDealModalV2: value,
        enableShareViaTextOption: value,
        enableShopperEnteredTrade: value,
        enableShopperQuoteDashboard: value,
        enableShortenedCommunityPropertyFlow: value,
        enableSimplifiedDesktopNav: value,
        enableSimplifiedMobileNav: value,
        enableSkipLeadForm: value,
        enableSnapshotForCMD: value,
        enableSnapshotForDs: value,
        enableSnapshotForSP: value,
        enableSponsorQueryParam: value,
        enableStateRollback: value,
        enableSubaruGTPImprovedWorkflow: value,
        enableSubaruGTPV2Service: value,
        enableTaxesAndFeesNewOptions: value,
        enableTextOptionShareDealModalV2: value,
        enableTradeInImprovedWorkflow: value,
        enableTradeInLeadFormSDP: value,
        enableTradeinLeadFormValuation: value,
        enableTradeInOnSDP: value,
        enableULIDTransition: value,
        enableUnlockedDS: value,
        enableV4Writting: value,
        enableV4WrittingByDealer: value,
        enableVcdaMashery: value,
        enableViewAllFees: value,
        enableVPPShortWorflow: value,
        enableWalkMeMv: value,
        enhancedDealDetails_F209893: value,
        fakeCreditDecisionFailure: value,
        fakeMenuExternalData: value,
        fakeReservationFailure: value,
        fakeTestDriveFailure: value,
        hideActivityIcon: value,
        hideDDPRespondButton: value,
        hideInactivePaymentAmounts: value,
        includeAcceleratePaymentFields: value,
        isActivEngageEnabled: value,
        isAioDxgScaLeadEnabled: value,
        isAIOEnabledForDealer: value,
        isAioOnVdpEnabled: value,
        isAmdInitDevoEnabled: value,
        isAmdSaveDevoEnabled: value,
        isAmsiTradeInEnabledOnSP: value,
        isConfirmPopupOnSdpEnabled: value,
        isCounterOfferEnabled: value,
        isCreditBureauEnabled: value,
        isDDCIntakeProcessorEnabledForDealer: value,
        isDealReadOnly: value,
        isDealSubSystemEnabled: value,
        isEPriceEnabled: value,
        isFordBlueAdvantageEnabled: value,
        isFsIntegrationEnableForDsAndSp: value,
        isGtmDataLayerV2Enabled: value,
        isHowItWorksEnabled: value,
        isInitDCEnabled: value,
        isLeadRoutingOverrideEnabled: value,
        isLivepersonCobrowserEnabledForDealer: value,
        isMenuPaymentsDisclaimerEnabled: value,
        isMultiScenarioPaymentOptimizationEnabled: value,
        isMyWalletTradeInEnabled: value,
        isPartnerIdLambdaEnabled: value,
        isPencilServiceEnabled: value,
        isPrePurchaseAgreementEnabled: value,
        isRatedCachedEnabled: value,
        isShortLinkEnabled: value,
        isTradeInAddedOnInitialDealStarterPaymentCall: value,
        isTradeInRelayEnabled: value,
        isTradeServiceEnabled: value,
        isUnifyDealSummaryEnabled: value,
        isVAutoEnabled: value,
        isVehicleProtectionPreviewEnabled: value,
        isVppMonthlyPaymentEnabled: value,
        kbbFieldValidation: value,
        limitVppLambdaToOnePlan: value,
        logDxgPayload: value,
        logMenuCommmonProductRequests: value,
        logMenuRatedRequests: value,
        menuCallsEnabled: value,
        menuHardAdds: value,
        menuUpdateWhenSdpTermsChange: value,
        mongoSyntheticTest: value,
        newAskAQuestionLogic: value,
        newDealersMapping: value,
        noAccessoriesPoC: value,
        openPopupOnUserEvent: value,
        paymentOrchestrationDealXg: value,
        phoneTrackingFeature: value,
        ratedCommercialFilter: value,
        redesignTradeSpBff: value,
        reduceModalMaxWidth: value,
        removeDuplicateMonths: value,
        routeToDdp: value,
        sendADealActivityStatus: value,
        shareWithQrCode: value,
        shouldOpenWithPartialPaymentData: value,
        showAcceptOffer: value,
        showAdminSoftPull: value,
        showCashOffer: value,
        showContinueToNextStepPostOffer: value,
        showCounterOfferLeaseTerms: value,
        showCustomSponsorDisclaimer: value,
        showKbbText: value,
        showMenuPaymentError: value,
        showOfferDetailMobileDialog: value,
        showPaymentsWithErrors: value,
        showReadOnlyDDP: value,
        showRecommendedOnVppRates: value,
        showShareDealComp: value,
        showUniFiDeepLink: value,
        showZipCodeOnLeadForm: value,
        showZipOnSummaryLeadForm: value,
        skipMenuSubmitNodeApiCall: value,
        smartInitOfferSaveForDash: value,
        subaruGtp: value,
        testDriveAfterTradeIn: value,
        testDriveAtHome: value,
        testDriveAtHomeAdf: value,
        testDriveAtHomeRedesign: value,
        testDriveCdk: value,
        testDriveMuiActivity: value,
        toggleFsDealRefId: value,
        toggleManagerTest: value,
        toggleMigrateSQtoFS: value,
        tradeInCdk: value,
        tradeInCdkCrud: value,
        tradeInSpBff: value,
        updateManualIncentivesMV: value,
        useAccessoriesFromInitCall: value,
        useAggregationPipelineDealVersionSearch: value,
        useAnyTermForPayment: value,
        useCategoryCodeForMenuProductsSelection: value,
        useCoOrgIdInVAutoAppraisalUrl: value,
        useCreditAppEmail: value,
        useGetMenuProductsFromSelection: value,
        useHeaderFooterState: value,
        useIncentivesFromPS: value,
        useL2DocUpload: value,
        useLambdaVppDrDash: value,
        useLambdaVppShopperPlatform: value,
        useLeadHoldingBin: value,
        useLocationIdOnTaxesAndFees: value,
        useNewCustomCreditTiers: value,
        useNewVCDA: value,
        useOverrideTaxRateForPayment: value,
        useOverrideTaxAmountForPayment: value,
        usePaymentBff: value,
        usePaymentGridMV: value,
        usePaymentProductsMonthlyPayment: value,
        usePaymentProductsOverSelectionId: value,
        usePaymentServiceEnabled: value,
        usePremiumPlanSelectionStrategy: value,
        usePSTotalAmountDueForCashDeals: value,
        useRedisDirectlyForPayments: value,
        useSDPRedesign: value,
        useShopperDOBAndLNameForPayment: value,
        useSPInitialRoutePaymentTerms: value,
        useVPPAlternativeCategoryCodes: value,
        useZipFromUrlOrCookie: value,
        viewDetailsVppNonRatedLongText: value,
        vrsTradeInSpBff: value,
        writeDealerToCore: value
    };
    return result;
};
exports.getFullFeatureToggleObject = getFullFeatureToggleObject;
var getAllFeatureToggleNames = function () {
    var obj = (0, exports.getFullFeatureToggleObject)(true);
    var toggleNames = [];
    for (var key in obj) {
        toggleNames.push(key);
    }
    return toggleNames;
};
exports.getAllFeatureToggleNames = getAllFeatureToggleNames;
